<div class="layout">
  <app-sidebar-menu></app-sidebar-menu>

  <div class="main-panel">
    <header class="topbar">
      <h1>Plataforma &Uacute;nica de Postulaci&oacute;n</h1>
      <div class="topbar-right">
        <app-header-notification-bell [rol]="rolSeleccionado"></app-header-notification-bell>
        <app-accessibility-toolbar></app-accessibility-toolbar>
        <app-user-session-summary></app-user-session-summary>
      </div>
    </header>
    <div class="content-breadcrumbs">
      <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
    </div>

    <main class="content">
      <section class="card">
        <h2>Mi Perfil</h2>
        <div class="info-banner" role="note">
          <span class="info-banner-icon" aria-hidden="true">i</span>
          <p>{{ descripcionPerfil }}</p>
        </div>

        <div class="tabs" role="tablist" aria-label="Secciones de Mi Perfil">
          <button
            *ngFor="let tab of tabsDisponibles"
            type="button"
            class="tab-btn"
            [class.active]="tabActiva === tab.key"
            role="tab"
            [attr.aria-selected]="tabActiva === tab.key"
            (click)="seleccionarTab(tab.key)"
          >
            {{ tab.label }}
          </button>
        </div>

        <app-perfil-postulaciones-tab *ngIf="tabActiva === 'postulaciones'" [rolSeleccionado]="rolSeleccionado"></app-perfil-postulaciones-tab>
        <app-perfil-datos-personales-tab *ngIf="tabActiva === 'datos_personales'"></app-perfil-datos-personales-tab>
        <app-perfil-curriculum-tab *ngIf="tabActiva === 'curriculum'"></app-perfil-curriculum-tab>

      </section>
    </main>
  </div>
</div>
